import { Stack } from '@mantine/core';
import {
  resetInitiativeCompletionFilters,
  toggleInitiativeCompletionSelection,
  toggleInitiativeCompletionTrends,
} from '../../../../store/process-analysis-store/process-analysis-store.actions';
import {
  useSelectedInitiativeCompletions,
  useSelectedInitiativeCompletionTrends,
} from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { ResetFiltersButton } from '../../../../components/filters/reset-filters-button';
import { useInitiativeCompletionData } from '../../hooks/initiative-data';
import { getDefaultInitiativeSelection } from '../../process-analysis.helpers';
import { InitiativeList } from '../initiative-list/initiative-list';

export const InitiativeCompletion = () => {
  const { data: initiativeCompletionData, isFetching } = useInitiativeCompletionData();
  const selectedInitiativeCompletions = useSelectedInitiativeCompletions();
  const selectedInitiativeCompletionTrends = useSelectedInitiativeCompletionTrends();

  const initiatives = initiativeCompletionData?.initiatives || [];

  return (
    <Stack pb={40}>
      <InitiativeList
        initiatives={initiatives}
        selectedInitiatives={selectedInitiativeCompletions}
        selectedTrends={selectedInitiativeCompletionTrends}
        onToggleSelection={toggleInitiativeCompletionSelection}
        onToggleTrend={toggleInitiativeCompletionTrends}
        isLoading={isFetching}
      />
      <ResetFiltersButton
        onClick={() => {
          const defaultSelection = getDefaultInitiativeSelection(initiatives);

          resetInitiativeCompletionFilters(defaultSelection);
        }}
      />
    </Stack>
  );
};
